import { HTTP } from '@util/http-p'

class MerchModel extends HTTP {
    get_list(data) {
        return this.request({
            url: 'apiadmin/merch/get_list',
            data: data
        })
    }

    post(data) {
        return this.request({
            url: 'apiadmin/merch/post',
            data: data,
            method: 'POST',
        })
    }

    delete(data) {
        return this.request({
            url: 'apiadmin/merch/merch_delete',
            data: {
                data: data,
                user_token: localStorage.user_token
            },
            method: 'POST',
        })
    }
 
}

export { MerchModel }